var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "blinki-input" },
    [
      _c("div", { staticClass: "flex blinki-input" }, [
        _c(
          "label",
          { staticClass: "typo__label blinki-textarea-label no-dhtmlx" },
          [
            _vm._v(_vm._s(_vm.title) + "\n    "),
            _vm.required
              ? _c("span", { staticClass: "main-color" }, [_vm._v("(*)")])
              : _vm._e(),
          ]
        ),
      ]),
      _vm._v(" "),
      !_vm.custom
        ? [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.listLocal,
                  expression: "listLocal",
                },
              ],
              staticStyle: {
                height: "0",
                border: "none",
                width: "0",
                display: "block",
              },
              attrs: { required: _vm.required },
              domProps: { value: _vm.listLocal },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.listLocal = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c(
              "multiselect",
              _vm._b(
                {
                  attrs: {
                    options: _vm.options,
                    multiple: _vm.multiple,
                    "close-on-select": !_vm.multiple,
                    "clear-on-select": false,
                    "preserve-search": true,
                    selectLabel: "",
                    deselectLabel: "",
                    selectedLabel: "sélectionnée",
                    placeholder: _vm.Localplaceholder,
                    label: "text",
                    "track-by": "value",
                    "preselect-first": false,
                  },
                  on: {
                    open: function ($event) {
                      return _vm.open($event)
                    },
                  },
                  model: {
                    value: _vm.listLocal,
                    callback: function ($$v) {
                      _vm.listLocal = $$v
                    },
                    expression: "listLocal",
                  },
                },
                "multiselect",
                _vm.$attrs,
                false
              )
            ),
          ]
        : [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.listLocal,
                  expression: "listLocal",
                },
              ],
              staticStyle: {
                height: "0",
                border: "none",
                width: "0",
                display: "block",
              },
              attrs: { required: _vm.required },
              domProps: { value: _vm.listLocal },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.listLocal = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c(
              "multiselect",
              _vm._b(
                {
                  attrs: {
                    options: _vm.options,
                    multiple: _vm.multiple,
                    "close-on-select": !_vm.multiple,
                    "clear-on-select": false,
                    "preserve-search": true,
                    selectLabel: "",
                    deselectLabel: "",
                    selectedLabel: "sélectionnée",
                    placeholder: _vm.Localplaceholder,
                    "preselect-first": false,
                  },
                  on: {
                    open: function ($event) {
                      return _vm.open($event)
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "selection",
                      fn: function ({ values, search, isOpen }) {
                        return [
                          false
                            ? _c(
                                "span",
                                { staticClass: "multiselect__single" },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(values.length) +
                                      " options sélectionnées\n                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.listLocal,
                    callback: function ($$v) {
                      _vm.listLocal = $$v
                    },
                    expression: "listLocal",
                  },
                },
                "multiselect",
                _vm.$attrs,
                false
              ),
              [
                _c(
                  "span",
                  { attrs: { slot: "noOptions" }, slot: "noOptions" },
                  [_vm._v("La liste est vide")]
                ),
                _vm._v(" "),
                _vm._v(" "),
                _c("span", { attrs: { slot: "noResult" }, slot: "noResult" }, [
                  _vm._v("Pas de résultat"),
                ]),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }